import axios from "axios";
import { BASE_URL } from "../../_constants/urlConstants";
import { getUUID } from "../../_utils/generalUtils";
import raiseError from "../raiseError";
import qs from "qs";
import { QMS } from "../../_constants/actionConstants";

const logError = (e) => console.error("ProDMS/QMS: Request failed with error:", e);

const divisionActions = {
  add: (newDivisionData) => async (dispatch) => {
    dispatch({ type: QMS.DIVISIONS.ADD });
    const apiEndpoint = BASE_URL + "/api/qms/Division";
    try {
      const res = await axios.post(apiEndpoint, newDivisionData);
      dispatch({ type: QMS.DIVISIONS.ADD_FULFILLED, divisions: res.data });
    } catch (e) {
      dispatch({ type: QMS.DIVISIONS.ADD_REJECTED });
      logError(e);
    }
  },
  update: (divisionData) => async (dispatch) => {
    dispatch({ type: QMS.DIVISIONS.UPDATE });
    const apiEndpoint = BASE_URL + "/api/qms/Division";
    try {
      const res = await axios.put(apiEndpoint, divisionData);
      dispatch({ type: QMS.DIVISIONS.UPDATE_FULFILLED, divisions: res.data });
    } catch (e) {
      dispatch({ type: QMS.DIVISIONS.UPDATE_REJECTED });
      logError(e);
    }
  },
  remove: (divisionId) => async (dispatch) => {
    dispatch({ type: QMS.DIVISIONS.REMOVE });
    const apiEndpoint = BASE_URL + "/api/qms/Division/" + divisionId;
    try {
      const res = await axios.delete(apiEndpoint);
      dispatch({ type: QMS.DIVISIONS.REMOVE_FULFILLED, divisions: res.data });
    } catch (e) {
      dispatch({ type: QMS.DIVISIONS.REMOVE_REJECTED });
      logError(e);
    }
  },
  getAll: () => async (dispatch) => {
    dispatch({ type: QMS.DIVISIONS.FETCH_ALL });
    const apiEndpoint = BASE_URL + "/api/qms/Division";
    try {
      const res = await axios.get(apiEndpoint);
      dispatch({ type: QMS.DIVISIONS.FETCH_ALL_FULFILLED, divisions: res.data });
    } catch (e) {
      dispatch({ type: QMS.DIVISIONS.FETCH_ALL_REJECTED });
      logError(e);
    }
  },
};

export default divisionActions;
